module.exports = __webpack_public_path__ + "static/media/quiz-1.0c314af1.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/quiz-1.png
// module id = 128
// module chunks = 0